module.exports = __webpack_public_path__ + "static/box.92510821.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/box.png
// module id = 250
// module chunks = 0